import {
  initState,
  initTraceRecordsState,
  DashboardStateType,
} from "#/modules/dashboard/redux/constants";
import * as actions from "#/modules/dashboard/redux/actionType";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function dashboard(
  state: DashboardStateType = initState,
  action: { type: string; data?: any },
): DashboardStateType {
  const {
    type,
    data,
  } = action;

  switch (type) {
    case actions.GET_LICENSE:
      return {
        ...state,
        license: {
          ...state.license,
          loading: true,
        },
      };
    case actions.GOT_LICENSE:
      return {
        ...state,
        license: {
          ...state.license,
          loading: false,
          results: data ?? null,
        },
      };
    case actions.GET_UNSAFE_REQUESTS:
      return {
        ...state,
        unsafeRequests: {
          ...state.unsafeRequests,
          loading: true,
        },
      };
    case actions.GOT_UNSAFE_REQUESTS:
      return {
        ...state,
        unsafeRequests: {
          ...state.unsafeRequests,
          loading: false,
          results: data ?? null,
        },
      };
    case actions.GET_STATS_SUMMARY:
      return {
        ...state,
        statsSummary: { ...state.statsSummary, loading: true },
      };
    case actions.GOT_STATS_SUMMARY:
      return {
        ...state,
        statsSummary: { loading: false, results: data ?? null },
      };
    case actions.GET_TRACE_RECORDS:
      return {
        ...state,
        traceRecords: {
          ...state.traceRecords,
          loading: true,
        },
      };
    case actions.GOT_TRACE_RECORDS: {
      const newRecords = data?.records ?? [];
      const isAppend = data?.append;
      const hasNext = newRecords.length > 0 && (data?.hasNext ?? false);
      return {
        ...state,
        traceRecords: {
          loading: false,
          records: isAppend
            ? [...state.traceRecords.records, ...newRecords]
            : newRecords,
          hasNext,
          nextCursor: hasNext ? data?.nextCursor : undefined,
        },
      };
    }
    case actions.RESET_TRACE_RECORDS:
      return {
        ...state,
        traceRecords: { ...initTraceRecordsState },
      };
    case actions.GET_TRACE_DETAIL:
      return {
        ...state,
        traceDetail: {
          loading: true,
          results: null,
        },
      };
    case actions.GOT_TRACE_DETAIL:
      return {
        ...state,
        traceDetail: {
          ...state.traceDetail,
          loading: false,
          results: data ?? null,
        },
      };
    case actions.GET_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          loading: true,
        },
      };
    case actions.GOT_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: {
          loading: false,
          results: data ?? null,
        },
      };
    case actions.GET_POLICY_NAME_MAPPING:
      return {
        ...state,
        policyNameMapping: {
          ...state.policyNameMapping,
          loading: true,
        },
      };
    case actions.GOT_POLICY_NAME_MAPPING:
      return {
        ...state,
        policyNameMapping: {
          loading: false,
          results: data ?? null,
        },
      };
    default:
      return state;
  }
}

export default dashboard;
